var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "totop __btn __btn_all_in __pointer",
      on: { click: _vm.startAutoReceive }
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(!_vm.isActive ? "Auto Receive Tx" : "Auto Receiving....") +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }